import { getMockAdapter } from '../axios/axios-mocks';

const setupCustomMocks = () => {
  const mock = getMockAdapter(1000);
  // add your custom mocks here:
  mock.onGet('/sample.json').networkError();
};

export default setupCustomMocks;
